"use strict";var e=require("styled-components");require("react");var r=require("prop-types"),t=require("@vds-core/utilities"),a=require("@vds-core/typography");function i(e){return e&&e.__esModule?e:{default:e}}var o=i(e),u=i(r);u.default.object,u.default.string,u.default.string,a.BodyConfig,t.calculateRem(4),a.TypographyConfig.getTypescale(),o.default.div.withConfig({displayName:"InputTextWrapper",componentId:"VDS__sc-1wiyhm4-0"})`
  display: block;
  margin-top: ${({margin:e,typescale:r})=>"VDS"===r?t.calculateRem(8):e};
`;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/inputs/cjs/components/InputField/InputText.js
// module id = 513
// module chunks = 0